import TopbarModel from './topbar.model';
import EVENTS from '@shared/events';
import { LANGUAGES } from "../../locales/locales";
import { makeNotifications } from "../../models/notification-model";

class TopbarController {
  constructor(HttpService, SessionService, PageService, CustomerApiService, StorageService, EventDispatcherService, $translate, $rootScope, $sce) {
    'ngInject';

    this.HttpService = HttpService;
    this.SessionService = SessionService;
    this.StorageService = StorageService;
    this.PageService = PageService;
    this.CustomerApiService = CustomerApiService;
    this.EventDispatcherService = EventDispatcherService;
    this.$translate = $translate;
    this.$rootScope = $rootScope;
    this.$sce = $sce;
    this.image = null;
  }

  $onInit() {
    this.model = new TopbarModel();
    this.session = this.SessionService.getSession();
    this.subscription = this.SessionService.session.subscribe((sessionDetails) => {
      if (sessionDetails) {
        this.model.customerName = sessionDetails.customerName;
        this.model.customerSince = sessionDetails.customerSince;
        this.model.selectedAvatar = sessionDetails.selectedAvatar;
        this.model.uploadedAvatar = sessionDetails.uploadedAvatar;

        this.loadAvatar();
      }
    });

    const locale = this.StorageService.getItem('locale');
    this.model.selectedLanguage.key = locale;
    this.model.selectedLanguage.language = LANGUAGES[locale];

    this.loadNotifications();

    // Add Listener for Web Socket Event
    this.eventSubscription = this.EventDispatcherService.addListener(EVENTS.TRANSACTION_PROCESSED, event => this.loadNotifications());
    this.eventSubscription = this.EventDispatcherService.addListener(EVENTS.GAUTH_RESET, event => this.loadNotifications());

    this.$rootScope.$on('$translateChangeSuccess', () => {
      this.loadNotifications();
    });

    this.EventDispatcherService.addListener(EVENTS.AVATAR_UPDATED, event => {
      this.model.selectedAvatar = event.payload.selected;
      this.model.uploadedAvatar = event.payload.uploaded;

      this.loadAvatar();
    });
  }

  $onDestroy() {
    this.subscription.unsubscribe();
    this.eventSubscription.remove();
  }

  loadNotifications() {
    this.CustomerApiService.getNotifications().then((response) => {
      let notifications = makeNotifications(response);

      Object.entries(notifications).forEach(([key, value]) => {
        value.message = value.message
          .replace('New referral', this.$translate.instant('New referral'))
          .replace('has been linked.', this.$translate.instant('has been linked.'))
          .replace('Referral', this.$translate.instant('Referral'))
          .replace('has been unlinked.', this.$translate.instant('has been unlinked.'))
          .replace('Product/s', this.$translate.instant('Product/s'))
          .replace('has been added.', this.$translate.instant('has been added.'))
          .replace('Transaction', this.$translate.instant('Transaction'))
          .replace('has been', this.$translate.instant('has been'))
          .replace('Deposit', this.$translate.instant('Deposit'))
          .replace('Withdraw', this.$translate.instant('Withdraw'))
          .replace('Transfer', this.$translate.instant('Transfer'))
          .replace('P2P Transfer', this.$translate.instant('P2P Transfer'))
          .replace('Approved', this.$translate.instant('Approved'))
          .replace('Acknowledged', this.$translate.instant('Acknowledged'))
          .replace('Saved', this.$translate.instant('Saved'));
      });

      this.model.notifications = notifications;
    });
  }

  readNotifications() {
    this.CustomerApiService.readNotifications().then(() => {
      this.model.markNotificationsAsRead();
    });
  }

  showSettingsModal() {
    this.PageService.showModal('settingsModal');
  }

  changeLanguage(languageKey) {
    this.$translate.use(languageKey);
    this.model.selectedLanguage.key = languageKey;
    this.model.selectedLanguage.language = LANGUAGES[languageKey];

    this.CustomerApiService.updateLanguage(languageKey).then((response) => {
      this.StorageService.setItem('locale', response.member.locale);
    });
  }

  loadAvatar() {
    if (this.model.uploadedAvatar) {
      this.CustomerApiService.getAvatar(this.model.uploadedAvatar).then((fileUri) => {
        this.HttpService.$http.get(fileUri, {responseType: 'arraybuffer'}).then((s3data) => {
          const fileObj = new Blob([s3data], {type: 'application/binary'});
          this.image = this.$sce.trustAsResourceUrl(URL.createObjectURL(fileObj));
        });
      });
    }    
  }
}

export default TopbarController;



// WEBPACK FOOTER //
// ./client/app/shared/ui/topbar/topbar.controller.js